export default __webpack_public_path__ + "static/media/empty.a767ece7.svg";